import { Companyinformation } from '../api/response_type/ShipmentTrackingResponse';

// BR-1929: per-company switches on the tracking page come from company_information.action_on_tracking —
// a list such as ["delivery_address","download_pod","show_reference"]. The API may send it as an array or
// as the JSON text; .includes works on both. null means "nothing set": the two buttons show, extras don't.

export const trackingSettingOn = (companyInfo: any, setting: string): boolean =>
  companyInfo != null &&
  companyInfo.action_on_tracking != null &&
  typeof companyInfo.action_on_tracking.includes === 'function' &&
  companyInfo.action_on_tracking.includes(setting);

// IT Sameday (15437) on the old page: the customer's reference beside the tracking events.
export const SHOW_REFERENCE = 'show_reference';

// Fragilistics' POD lives in PODFather, not with us. The old page asked /ePodFather when a number was not
// found; React does the same, on the Fragilistics site only (the API enforces it too — PodFatherGuard).
export const PODFATHER_HOSTS = ['tracking.fragilistics.co.uk'];
export const podFatherHost = (): boolean => PODFATHER_HOSTS.includes(window.location.hostname.toLowerCase());

// BR-2011: company_information is per COMPANY, so a brand below company level (a warehouse with its own tracking
// domain) needs its name and logo set by domain. 319 Logistics is FITS (20516) warehouse 669 "FITS EXPRESS 319",
// not a company; the old page did the same per domain in css/fitz-track-319.css. It is keyed by domain, not
// warehouse, because the header shows before any search. One entry per domain; any company_information field may be set (logo, company_name,
// support_email, support_phone, support_hours, instruction_messge) and the rest still come from the API.
// withHostBrand is applied where the slice stores companyinfo, so every component sees the brand.
export const HOST_BRANDS: Record<string, Partial<Companyinformation>> = {
  'tracking.319logistics.com': {
    logo: 'https://319logistics.com/wp-content/uploads/2025/04/319WEBP.webp',
    company_name: '319 Logistics',
  },
};
export const hostBrand = (): Partial<Companyinformation> | undefined => HOST_BRANDS[window.location.hostname.toLowerCase()];
export const hostLogo = (): string | undefined => hostBrand()?.logo;
export const withHostBrand = <T extends object>(companyInfo: T): T => {
  const brand = hostBrand();
  return companyInfo != null && brand ? { ...companyInfo, ...brand } : companyInfo;
};

// BR-1929: the API converts some times (driver last sync) to the zone we send. This was hard-coded to
// "Asia/Calcutta" (+5:30 for UK visitors); send the visitor's own zone instead.
export const browserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London';
  } catch {
    return 'Europe/London';
  }
};
